export const getUsers = (payload?: any) => ({
    type: "@saga/GET_USERS",
    payload
});

